var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.188 24C49.842 23.997 50.37 23.466 50.37 22.815C50.37 22.161 49.839 21.633 49.185 21.633C48.531 21.633 48 22.161 48 22.815C48 23.469 48.531 24 49.185 24",
    stroke: "url(#paint0_linear_407_2478)",
    strokeWidth: 3.05535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.188 11.31C49.809 11.307 50.31 10.803 50.31 10.182C50.31 9.561 49.806 9.06 49.185 9.06C48.564 9.06 48.06 9.564 48.06 10.185C48.06 10.806 48.564 11.31 49.188 11.31",
    stroke: "url(#paint1_linear_407_2478)",
    strokeWidth: 3.05535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.94 22.812C62.94 22.191 62.436 21.69 61.815 21.69C61.194 21.69 60.693 22.194 60.693 22.815C60.693 23.436 61.197 23.94 61.818 23.94C62.436 23.94 62.94 23.436 62.94 22.812",
    stroke: "url(#paint2_linear_407_2478)",
    strokeWidth: 3.05535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 63V9C21.087 9 9 21.087 9 36C9 50.913 21.087 63 36 63C50.913 63 63 50.913 63 36H36",
    stroke: "url(#paint3_linear_407_2478)",
    strokeWidth: 3.05535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_2478",
    x1: 47.4225,
    y1: 22.8165,
    x2: 51.0787,
    y2: 22.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_407_2478",
    x1: 47.4225,
    y1: 10.185,
    x2: 51.0787,
    y2: 10.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_407_2478",
    x1: 60.054,
    y1: 22.815,
    x2: 63.7102,
    y2: 22.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_407_2478",
    x1: 4.275,
    y1: 36,
    x2: 70.0875,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableIcon1);
export default __webpack_public_path__ + "static/media/available-icon-1.ccc2e09d3f0cb57832c3025b0ca0a5b9.svg";
export { ForwardRef as ReactComponent };